import { render } from "./ContactUs.vue?vue&type=template&id=93ed8f4c"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=93ed8f4c&lang=scss"
script.render = render

export default script